import { useState } from 'react';
import { Box } from '@gemini/core';
import { FeedbackMessage } from '@gemini/ui';
import { useTranslation } from '@aviv-unified-frontend/runtime/i18n';
import { NAME_SPACE } from '@mfe-presentation/hooks/useLoadTranslations';

const LegacyUpdateMessage = () => {
    const { t } = useTranslation(NAME_SPACE);
    const [showMessage, setShowMessage] = useState(true);

    const title = t('step_address.legacy_update_message.title');
    const message = t('step_address.legacy_update_message.content');

    return (
        <Box testId="welcome-message" marginTop="spacing.16" width="100%">
            {showMessage && (
                <FeedbackMessage
                    title={title}
                    variant="info"
                    endButtonProps={undefined}
                    onClose={() => setShowMessage(false)}
                >
                    <Box whiteSpace="pre-line">{message}</Box>
                </FeedbackMessage>
            )}
        </Box>
    );
};

export default LegacyUpdateMessage;
